<template>

  <div class="">
    <UserList
      :OpenUpdateModal="OpenUpdateModal"
      :OpenCreateModal="OpenCreateModal"
      :highlightedUserId="highlightedUserId"
      :clearHighlight="ClearUserHighlight"
    ></UserList>
  </div>

  <Teleport to="body">
    <div
      v-if="isRecordLocatorLoading"
      class="directory-record-loader"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div class="directory-record-loader__dialog">
        <span class="directory-record-loader__spinner" aria-hidden="true"></span>
        <h3 class="directory-record-loader__title">{{ recordLocatorTitle }}</h3>
        <p class="directory-record-loader__message">{{ recordLocatorMessage }}</p>
      </div>
    </div>
  </Teleport>

  <Modal idModal="CreateUserModal" :headerTitle="$t('Create User')" modalSize="modal-xl">
    <div class="user-modal-form">
     <div class="form-group">
        <label :class="{ 'required-style': !newUser.companyType }">{{ $t('Company Type') }} </label>
        <select class="form-select" v-model="newUser.companyType" >
            <option v-for="(item, key) in CompanyTypeList" :key="key" :value="item.id">{{ $t(item.value) }}</option>
        </select>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group" v-if="newUser.companyType==CompanyType.MMOSER">
                <label>{{ $t('Search From KC') }}</label>
                <!-- <input type="text" class="form-control" placeholder="John" v-model="newUser.firstName" /> -->
                <Select2 
                    :filterQuery="SearchFromKc"
                    indexValue="firstName"
                    labelName="fullname"
                    :placeHolder="$t('Search User from KC')"
                    :onOptionClick="AppendSelectedKcUser"
                    ref="select2UserExist"
                ></Select2>
            </div>
            <div class="form-group">
                <label :class="{ 'required-style': !newUser.firstName }">{{ $t('First Name') }}</label>
                <input type="text" class="form-control" placeholder="John" v-model="newUser.firstName" />
                <small class="text-warning" v-if="!newUser.firstName&&SaveClicked">{{ $t('Required') }}</small>
            </div>
            <div class="form-group">
                <label :class="{ 'required-style': !newUser.lastName }">{{ $t('Last Name') }} </label>
                <input type="text" class="form-control" placeholder="Doe" v-model="newUser.lastName" />
                <small class="text-warning" v-if="!newUser.lastName&&SaveClicked">{{ $t('Required') }}</small>
            </div>
            <div class="form-group" v-if="newUser.companyType==CompanyType.MMOSER">
                <label :class="{ 'required-style': !newUser.roleId }">{{ $t('Role') }}</label>
                  <select class="form-select" v-model="newUser.roleId">
                    <option value="">{{ $t('Please Select Role') }}</option>
                    <option v-for="(item, key) in roles" :key="key" :value="item._id">{{item.roleName}}</option>
                </select>
                <small class="text-warning" v-if="!newUser.roleId&&SaveClicked">{{ $t('Required') }}</small>
            </div>
            <div class="form-group"  v-else-if="newUser.companyType==CompanyType.CLIENT">
                <label>{{ $t('Role') }} </label>
                <input type="text" class="form-control" readonly :value="$t('Client')" />
            </div>
            <div class="form-group"  v-else>
                <label>{{ $t('Role') }}</label>
                <input type="text" class="form-control" readonly :value="$t(CompanyTypeList[newUser.companyType - 1].value)" />
            </div>
            <div class="form-group">
                <label :class="{ 'required-style': !newUser.email }">{{ $t('Email') }} </label>
                <input type="text" class="form-control" placeholder="sample@gmail.com" v-model="newUser.email" />
                <small class="text-warning" v-if="SaveClicked && (!newUser.email || !IsValidEmail(newUser.email))">{{ newUser.email ? $t('Invalid email') : $t('Required') }}</small>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group pb-1">
                <label>{{ $t('Office') }}</label>
                <select class="form-select" v-model="newUser.officeId" >
                    <option value="">{{ $t('Select Office') }}</option>
                    <option v-for="(item, index) in offices" :key="index" :value="item._id">{{item.officeName}}</option>
                </select>
                <span class="text-warning" v-if="SaveClicked && !newUser.officeId">{{ $t('Required') }}</span>
            </div>
            <div class="form-group">
                <label>{{ $t('Photo Url') }}</label>
                <input type="text" class="form-control" placeholder="https://url-to-image" v-model="newUser.photoUrl" />
            </div>
            <div class="form-group">
                <label>{{ $t('Address') }}</label>
                <textarea
                    class="form-control"
                    v-model="newUser.address"
                    placeholder="Holiday St. Building #123"
                    :maxlength="addressMaxLength"
                    @input="LimitTextField(newUser, 'address', addressMaxLength)"
                ></textarea>
                <small class="text-muted">{{ (newUser.address || '').length }}/{{ addressMaxLength }}</small>
            </div>
            <div class="form-group" v-for="(item, key) in addedContacts" :key="key">
                <div class="d-flex justify-content-between">
                    <label> {{ $t('Contact Number') }}</label>
                    <small v-if="key!=0" @click="RemoveContact(key,1)" class="text-warning" role="button"><i class="fa-solid fa-minus"></i> {{ $t('Remove') }}</small>    
                </div>
                <input
                    type="text"
                    class="form-control"
                    placeholder="6312345678910"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    v-model="item.value"
                    @input="NormalizeContactNumber(item)"
                />
            </div>
            <div>
                <small @click="AddNewLineContact(1)" class="text-primary" role="button"><i class="fa-solid fa-plus"></i> {{ $t('Add Contact Number') }}</small>
            </div>
            
        </div>
        <div class="col-md-6"  v-if="newUser.companyType!=CompanyType.MMOSER">
                <div class="form-group">
                    <label :class="{ 'required-style': !newUser.companyName }">{{ $t('Company') }} </label>
                    <AutocompleteSelect
                    v-model:optionValue="newUser.companyName"
                    :filterQuery="SearchCompanies"
                    indexValue="companyName"
                    :placeHolder="$t('Search Company')"
                    :onOptionClick="OnNewCompanyClick"
                    :onClear="OnNewCompanyClear"
                    ></AutocompleteSelect>
                    <small class="text-warning" v-if="!newUser.companyName&&SaveClicked">{{ $t('Required') }}</small>
                </div>
            </div>
            <div class="col-md-6" v-if="newUser.companyType!=CompanyType.MMOSER">
                <div class="form-group">
                    <label :class="{ 'required-style': !newUser.companyAddress }">{{ $t('Company Address') }}</label>
                    <textarea class="form-control" style="white-space: pre-wrap" v-model="newUser.companyAddress"></textarea>
                    <small class="text-warning" v-if="!newUser.companyAddress&&SaveClicked">{{ $t('Required') }}</small>
                </div>
            </div>
    </div>
    </div>

    <template v-slot:actions>
        <button type="button" ref="closeModalCreate" class="btn user-modal-btn user-modal-btn--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
        <button class="btn user-modal-btn user-modal-btn--submit" ref="CreateBtn" @click="SaveNewUser">{{ $t('Add User') }}</button>
      </template>
  </Modal>

  <Modal idModal="UpdateUserModal" :headerTitle="$t('Edit User')" modalSize="modal-xl">
    <fieldset class="user-modal-form" :disabled="isUpdateLoading">
        <div class="form-group">
            <label :class="{ 'required-style': !updatedUser.companyType }">{{ $t('Company Type') }} </label>
            <select class="form-select" v-model="updatedUser.companyType" >
                <option v-for="(item, key) in CompanyTypeList" :key="key" :value="item.id">{{ $t(item.value) }}</option>
            </select>
        </div>
        <div class="row">
            <div class="col-md-6">
                
                <div class="form-group">
                    <label :class="{ 'required-style': !updatedUser.firstName }">{{ $t('First Name') }}</label>
                    <input type="text" class="form-control" placeholder="John" v-model="updatedUser.firstName" />
                    <small class="text-warning" v-if="!updatedUser.firstName&&isUpdateClicked">{{ $t('Required') }}</small>
                </div>
                <div class="form-group">
                    <label :class="{ 'required-style': !updatedUser.lastName }">{{ $t('Last Name') }} </label>
                    <input type="text" class="form-control" placeholder="Doe" v-model="updatedUser.lastName" />
                    <small class="text-warning" v-if="!updatedUser.lastName&&isUpdateClicked">{{ $t('Required') }}</small>
                </div>
                <div class="form-group" v-if="updatedUser.companyType==CompanyType.MMOSER">
                    <label :class="{ 'required-style': !updatedUser.roleId }">{{ $t('Role') }}</label>
                    <select class="form-select" v-model="updatedUser.roleId">
                        <option value="">{{ $t('Please Select Role') }}</option>
                        <option v-for="(item, key) in roles" :key="key" :value="item._id">{{item.roleName}}</option>
                    </select>
                    <small class="text-warning" v-if="!updatedUser.roleId&&isUpdateClicked">{{ $t('Required') }}</small>
                </div>
                <div class="form-group"  v-else-if="updatedUser.companyType==CompanyType.CLIENT">
                    <label>{{ $t('Role') }} </label>
                    <input type="text" class="form-control" readonly :value="$t('Client')" />
                </div>
                <div class="form-group">
                    <label :class="{ 'required-style': !updatedUser.email }">{{ $t('Email') }} </label>
                    <input type="text" class="form-control" placeholder="sample@gmail.com" v-model="updatedUser.email" />
                    <small class="text-warning" v-if="isUpdateClicked && (!updatedUser.email || !IsValidEmail(updatedUser.email))">{{ updatedUser.email ? $t('Invalid email') : $t('Required') }}</small>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group pb-1">
                    <label>{{ $t('Office') }}</label>
                    <select class="form-select" v-model="updatedUser.officeId" >
                        <option value="">{{ $t('Select Office') }}</option>
                        <option v-for="(item, index) in offices" :key="index" :value="item._id">{{item.officeName}}</option>
                    </select>
                    <span class="text-warning" v-if="isUpdateClicked && !updatedUser.officeId">{{ $t('Required') }}</span>
                </div>
                <div class="form-group">
                    <label>{{ $t('Photo Url') }}</label>
                    <input type="text" class="form-control" placeholder="https://url-to-image" v-model="updatedUser.photoUrl" />
                </div>
                <div class="form-group">
                    <label>{{ $t('Address') }}</label>
                    <textarea
                        class="form-control"
                        v-model="updatedUser.address"
                        placeholder="Holiday St. Building #123"
                        :maxlength="addressMaxLength"
                        @input="LimitTextField(updatedUser, 'address', addressMaxLength)"
                    ></textarea>
                    <small class="text-muted">{{ (updatedUser.address || '').length }}/{{ addressMaxLength }}</small>
                </div>
                <div class="form-group" v-for="(item, key) in updatedContacts" :key="key">
                    <div class="d-flex justify-content-between">
                        <label> {{ $t('Contact Number') }}</label>
                        <small v-if="key!=0" @click="RemoveContact(key,2)" class="text-warning" role="button"><i class="fa-solid fa-minus"></i> {{ $t('Remove') }}</small>    
                    </div>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="6312345678910"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        v-model="item.value"
                        @input="NormalizeContactNumber(item)"
                    />
                </div>
                <div>
                    <small @click="AddNewLineContact(2)" class="text-primary" role="button"><i class="fa-solid fa-plus"></i> {{ $t('Add Contact Number') }}</small>
                </div>
                
            </div>
            <div class="col-md-6"  v-if="updatedUser.companyType!=CompanyType.MMOSER">
                <div class="form-group">
                    <label :class="{ 'required-style': !updatedUser.companyName }">{{ $t('Company') }} </label>
                    <!-- <input type="text" class="form-control" placeholder="Company Name" v-model="updatedUser.company" /> -->
                    <!-- <Select2 
                    :filterQuery="SearchCompanies"
                    indexValue="_id"
                    labelName="companyName"
                    :placeHolder="$t('Search Company')"
                    ref="select2UsercompanyUpdate"
                    :iniLabel="updatedUser.companyName"
                    :optionValue="updatedUser.companyId"
                    v-model:optionValue="updatedUser.companyId"
                    ></Select2> -->
                    <AutocompleteSelect
                    :optionValue="updatedUser.companyName"
                    v-model:optionValue="updatedUser.companyName"
                    :filterQuery="SearchCompanies"
                    indexValue="companyName"
                    placeHolder="Search Company"
                    :onOptionClick="OnCompanyClick"
                    :onClear="OnCompanyClear"
                    ></AutocompleteSelect>
                    <small class="text-warning" v-if="!updatedUser.companyName&&isUpdateClicked">{{ $t('Required') }}</small>
                </div>
            </div>
            <div class="col-md-6" v-if="updatedUser.companyType!=CompanyType.MMOSER">
                <div class="form-group">
                    <label :class="{ 'required-style': !updatedUser.companyAddress }">{{ $t('Company Address') }}</label>
                    <textarea class="form-control" style="white-space: pre-wrap" v-model="updatedUser.companyAddress"></textarea>
                    <small class="text-warning" v-if="!updatedUser.companyAddress&&isUpdateClicked">{{ $t('Required') }}</small>
                </div>
            </div>
        </div>
    </fieldset>

    <template v-slot:actions>
    <button type="button" ref="closeModalUpdate" class="btn user-modal-btn user-modal-btn--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
    <button class="btn btn-primary" ref="updateBtn"  @click="updateUser"><i class="fa-solid fa-floppy-disk"></i> {{ $t('Save Changes') }}</button>
    </template>
  </Modal>


</template>
<script src="@/assets/directoryJs/User.js" />
